import styled from 'styled-components';
import { ob } from 'components/Onboarding';

/* ---------- "Others" room dropdown (searchable list of every category) ---------- */

export const DropdownBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  background: rgba(26, 26, 26, 0.45);
`;

export const DropdownTrigger = styled.div<{ $open?: boolean; $filled?: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 14px;
  border: 1px solid ${({ $open }) => ($open ? ob.primary : ob.border)};
  border-radius: 12px;
  background: #fff;
  box-shadow: ${({ $open }) => ($open ? `0 0 0 3px ${ob.ring}` : '0 1px 1px rgba(26,26,26,0.03)')};
  color: ${({ $filled }) => ($filled ? ob.text : ob.muted)};
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  transition: all 140ms ease;
  &:hover {
    border-color: rgba(255, 113, 15, 0.4);
  }
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  svg {
    flex-shrink: 0;
    margin-left: 8px;
    color: ${ob.muted};
  }
`;

export const DropdownPanel = styled.div`
  overflow: hidden;
  border: 1px solid ${ob.border};
  border-radius: 14px;
  background: #fff;
  box-shadow: ${ob.shadowStrong};
`;

export const DropdownSearch = styled.div`
  padding: 10px 12px;
  border-bottom: 1px solid ${ob.border};
  input {
    width: 100%;
    height: 38px;
    padding: 0 12px;
    border: 1px solid ${ob.border};
    border-radius: 10px;
    background: #fff;
    color: ${ob.text};
    font-family: inherit;
    font-size: 14px;
    outline: none;
    box-sizing: border-box;
    &:focus {
      border-color: ${ob.primary};
      box-shadow: 0 0 0 3px ${ob.ring};
    }
  }
`;

export const DropdownList = styled.div`
  max-height: 220px;
  overflow-y: auto;
`;

export const DropdownOption = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  background: ${({ $active }) => ($active ? ob.primarySoft : 'transparent')};
  color: ${({ $active }) => ($active ? ob.primary : ob.text)};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;
  &:hover {
    background: ${({ $active }) => ($active ? ob.primarySoft : ob.surface)};
  }
`;

export const DropdownEmpty = styled.div`
  padding: 16px;
  text-align: center;
  color: ${ob.muted};
  font-size: 14px;
`;

/* ---------- Photos ---------- */

export const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  @media (min-width: 640px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  > * {
    min-width: 0;
  }
`;

export const PhotoTile = styled.div<{ $cover?: boolean }>`
  min-width: 0;
  overflow: hidden;
  border: 1px solid ${({ $cover }) => ($cover ? 'rgba(255,113,15,0.6)' : ob.border)};
  border-radius: 16px;
  background: #fff;
  box-shadow: ${({ $cover }) => ($cover ? '0 0 0 1px rgba(255,113,15,0.4)' : '0 1px 2px rgba(26,26,26,0.04)')};
  .media {
    position: relative;
  }
  .media img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    aspect-ratio: 4 / 3;
    object-fit: cover;
  }
  .shade {
    position: absolute;
    inset: auto 0 0 0;
    height: 48px;
    background: linear-gradient(to top, rgba(26, 26, 26, 0.45), transparent);
    pointer-events: none;
  }
  .cover {
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 999px;
    background: ${ob.primary};
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .room {
    position: absolute;
    left: 8px;
    bottom: 8px;
    max-width: calc(100% - 16px);
    overflow: hidden;
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    font-size: 11px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;
    padding: 4px;
    border-top: 1px solid rgba(238, 235, 230, 0.7);
  }
  .actions select {
    flex: 1 1 90px;
    min-width: 0;
    max-width: 100%;
    height: 32px;
    padding: 0 6px;
    border: 1px solid ${ob.border};
    border-radius: 8px;
    background: #fff;
    font-family: inherit;
    font-size: 12px;
  }
  .actions .btns {
    display: flex;
    margin-left: auto;
  }
`;

export const TileButton = styled.button<{ $danger?: boolean; $on?: boolean }>`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: ${({ $on }) => ($on ? ob.primary : ob.muted)};
  cursor: pointer;
  transition: all 140ms ease;
  &:hover:not(:disabled) {
    background: ${({ $danger }) => ($danger ? 'rgba(190,18,60,0.08)' : ob.primarySoft)};
    color: ${({ $danger }) => ($danger ? ob.danger : ob.primary)};
  }
  &:disabled {
    cursor: default;
  }
`;

export const UploadTile = styled.div<{ $active?: boolean }>`
  display: grid;
  place-items: center;
  aspect-ratio: 4 / 3;
  padding: 8px;
  border: 1px dashed ${({ $active }) => ($active ? ob.primary : 'rgba(255,113,15,0.35)')};
  border-radius: 16px;
  background: ${({ $active }) => ($active ? ob.primarySoft : 'rgba(255,240,230,0.35)')};
  text-align: center;
  cursor: pointer;
  transition: all 140ms ease;
  &:hover {
    border-color: rgba(255, 113, 15, 0.6);
    background: rgba(255, 240, 230, 0.6);
  }
  .inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .ic {
    display: grid;
    place-items: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #fff;
    color: ${ob.primary};
    box-shadow: 0 1px 2px rgba(26, 26, 26, 0.06);
  }
  .t {
    font-size: 13px;
    font-weight: 600;
    color: ${ob.primary};
  }
  .s {
    font-size: 10px;
    font-weight: 500;
    color: ${ob.muted};
  }
`;

export const Hint = styled.p<{ $warn?: boolean }>`
  margin: 0;
  font-size: 12px;
  color: ${({ $warn }) => ($warn ? ob.warning : ob.muted)};
`;

/* ---------- Video ---------- */

export const PromoBanner = styled.div`
  position: relative;
  overflow: hidden;
  padding: 16px;
  border: 1px solid rgba(255, 113, 15, 0.2);
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(255, 113, 15, 0.09), rgba(255, 113, 15, 0.04) 50%, #fff);
  @media (min-width: 640px) {
    padding: 20px;
  }
  .row {
    display: flex;
    flex-direction: column;
    gap: 14px;
    @media (min-width: 640px) {
      flex-direction: row;
      align-items: center;
    }
  }
  .stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 14px;
    border-radius: 12px;
    background: rgba(255, 113, 15, 0.1);
    @media (min-width: 640px) {
      flex-direction: row;
      gap: 16px;
      padding: 0 24px 0 0;
      border-radius: 0;
      border-right: 1px solid rgba(255, 113, 15, 0.2);
      background: transparent;
    }
  }
  .big {
    font-family: ${ob.fontDisplay};
    font-size: 24px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.01em;
    color: ${ob.primary};
    @media (min-width: 640px) {
      font-size: 48px;
    }
  }
  .small {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 2px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 113, 15, 0.8);
    @media (min-width: 640px) {
      margin-top: 0;
      font-size: 11px;
    }
  }
  .copy {
    min-width: 0;
  }
  .head {
    margin: 0;
    font-family: ${ob.fontDisplay};
    font-size: 14px;
    font-weight: 700;
    line-height: 1.35;
    @media (min-width: 640px) {
      font-size: 18px;
    }
  }
  .sub {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 8px 0 0;
    font-size: 13px;
    line-height: 1.6;
    color: ${ob.muted};
    svg {
      margin-top: 4px;
      flex-shrink: 0;
      color: ${ob.primary};
    }
  }
`;

export const VideoDrop = styled.button<{ $active?: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 24px 16px;
  border: 1px dashed ${({ $active }) => ($active ? ob.primary : ob.border)};
  border-radius: 14px;
  background: ${({ $active }) => ($active ? ob.primarySoft : ob.surface)};
  color: ${ob.primary};
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 140ms ease;
  &:hover {
    background: rgba(255, 240, 230, 0.5);
  }
  .s {
    font-size: 12px;
    font-weight: 400;
    color: ${ob.muted};
  }
`;

export const VideoRow = styled.div`
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid ${ob.border};
  border-radius: 14px;
  background: #fff;
  video {
    display: block;
    width: 100%;
    max-height: 280px;
    background: #000;
  }
  .meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 14px;
  }
  .name {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 500;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .badge {
    display: grid;
    place-items: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 8px;
    background: ${ob.primarySoft};
    color: ${ob.primary};
  }
  .links {
    display: flex;
    flex-shrink: 0;
    gap: 12px;
    button {
      border: 0;
      background: none;
      font-family: inherit;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
    }
    .change {
      color: ${ob.primary};
    }
    .remove {
      color: ${ob.danger};
    }
  }
`;
